import { CustomTabPanel } from "@/erp/sale"
import {
  a11yProps, EstadoFactibilidadEnum, EstadosAgendamientoEnumChoice, EstadosLlamadaEnumChoice
  , handleErrorForm, newMotivoAgendaCorporativo, ROUTER_PATHS, useTabsFormOnly
} from "@/shared"
import { CustomButtunsRejectConfirm, FormTabsOnly, TabsFormBoxScene } from "@/shared/components/ui"

import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface"
import { IProspectoCorporativo } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface"
import { Tab, Typography } from "@mui/material"
import { useForm } from "react-hook-form"
import { useEffect, useState } from "react"
import { MaterialesKey, useFlotasStore, useMaterialesUtilizadosStore } from "@/store/erp"
import useCalendarioInstalacionPyl from "../../agendamientonoc/shared/store/useCalendarioInstalacionPyl.store"
import { useNavigate } from "react-router-dom"
import { yupResolver } from "@hookform/resolvers/yup"
import TabInformacionAgendaNoc from "./TabInformacionAgendaNoc"
import TabInformacionAdicionalAgendaNoc from "./TabInformacionAdicionalAgendaNoc"
import { usePostAgendamientoCorporativo } from "@/shared/actions/erp/agendamiento_corporativo"
import { putFactibilidadCorporativo } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions"
import { postPoligono, useFetchCoberturasCiudadEnabled, useFetchCoberturasProvincia, useFetchCoberturasSector } from "@/shared/actions/erp"
import dayjs from "dayjs"
import { putPreventaCorporativo } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action"
import TabMaterialesEquiposNoc from "./TabMaterialesEquiposNoc"
import { IFactibilidadCorporativo } from "@/shared/interfaces/erp/factibilidad_corporativo"

export type IVentaCorporativoNoc =
  Omit<IFactibilidadCorporativo, 'preventa_coorporativa_data' | 'trazo_venta_data'>
  & Omit<IPreventaCorporativoForm2, 'prospecto_corporativo_data' | 'trazo_venta_data'>
  & Omit<IProspectoCorporativo, 'trazo_venta_data'>
  & {
    estado_llamada: string
    observacion_llamada: string
    flota: string
  }

export type FormAgendaCorporativo = {
  flota: string
  celular_1: string
  estado_llamada: string
  observacion_llamada: string
  // coordenada_cliente: string
  coordenada_fusion: string
  direccion_fusion?: string
  coordenada_servicio: string
  coordenada_empresa: string
  fecha_instalacion: string
  hora_instalacion: string
  provincia: string
  ciudad: string
  zona?: string
  sector?: string
  direccion_servicio: string

  celular_2?: string
  provincia_nombre?: string
  ciudad_nombre?: string
  zona_nombre?: string
  sector_tentativo?: string
}
interface SaveAgendamientoNocProps {
  titlePage: string
  factibilidadCorporativa: IFactibilidadCorporativo
}


export default function SaveAgendamientoNoc({
  titlePage,
  factibilidadCorporativa

}: SaveAgendamientoNocProps) {

  const navigate = useNavigate()

  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });

  const [noForm, setNoForm] = useState<IVentaCorporativoNoc | null>(null)

  ///* form --------------------
  const form = useForm<FormAgendaCorporativo, any, FormAgendaCorporativo>({
    resolver: yupResolver(newMotivoAgendaCorporativo),
    defaultValues: {
      coordenada_fusion: factibilidadCorporativa?.preventa_corporativa_data?.coordenada_fusion ?? '0,0',
      coordenada_empresa: factibilidadCorporativa?.preventa_corporativa_data?.coordenada_empresa ?? '0,0',
      coordenada_servicio: factibilidadCorporativa?.preventa_corporativa_data?.coordenada_servicio ?? '0.0',
      direccion_servicio: factibilidadCorporativa?.preventa_corporativa_data?.direccion_servicio
    }
  });

  const {
    handleSubmit,
    reset,
  } = form;

  ///* Store
  const { flotas:flotasCorporativas, getFlotas } = useFlotasStore()

  const isVisibleCalendario = useCalendarioInstalacionPyl(s => s.isVisibleCalendario)

  const clearSelectedItems = useMaterialesUtilizadosStore(s => s.clearSelectedItems);
  const ingresoProductos = useMaterialesUtilizadosStore(s => s.ingresoProductos);
  const setSelectedItems = useMaterialesUtilizadosStore(
    (s) => s.setSelectedItems
  );

  ///* react query

  //const [selectedProvince, setSelectedProvince] = useState('');
  //const [, setSelectedCity] = useState('');

  const { data: provinceByCountry, isLoading: isLoadingProvinceByCountry } =
    useFetchCoberturasProvincia({
      page_size: 1000,
      cobertura: undefined,
      estado: true
    });

  const { data: citiesByProvince, isLoading: isLoadingCities } =
    useFetchCoberturasCiudadEnabled({
      enabled: !!form.watch().provincia,
      params: {
        provincia: form.watch().provincia,
        page_size: 1000,
        estado: true,
        cobertura: undefined,
      },
    });

  const {
    mutateAsync: mutateAsyncAgendaCorporativo
  } = usePostAgendamientoCorporativo({
    navigate,
    returnUrl: ROUTER_PATHS.noc.agendamientoNocNav
  })

  const { data: sectorsByZonePaging, isLoading: isLoadingSectors } =
    useFetchCoberturasSector({
      zona: form.watch().zona,
      page_size: 1000,
      cobertura: true,
      estado: true
    }, !!form.watch().zona);

  ///* use effect
  useEffect(() => {

    const { prospecto_corporativo_data,
      preventa_corporativa_data,
      provincia_data,
      ciudad_data,
      zona_data,
      ...rest } = factibilidadCorporativa
    reset({
      celular_1: preventa_corporativa_data?.celular_1,
      celular_2: preventa_corporativa_data?.celular_2,
      coordenada_fusion: preventa_corporativa_data?.coordenada_fusion,
      zona: zona_data?.codigo!
    })

    setSelectedItems(preventa_corporativa_data?.servicios_adicionales || [], MaterialesKey.serviciosAdicionalesDigitales)


    if (preventa_corporativa_data?.coordenada_servicio && preventa_corporativa_data?.sector && !isLoadingSectors) {


      try {
        const coord = preventa_corporativa_data?.coordenada_servicio.split(',')

        async function dataPoligono() {
          const resp = (await postPoligono({
            latitud: coord.at(0)!,
            longitud: coord.at(1)!
          })).data

          reset({
            ...form.getValues(),
            provincia: resp.provincia_data?.codigo,
            ciudad: resp.ciudad_data?.codigo,
            zona: resp.codigo,
            ///*
            provincia_nombre: resp.provincia_data?.nombre,
            ciudad_nombre: resp.ciudad_data?.nombre,
            zona_nombre: resp.nombre,
            sector: rest.sector_data?.codigo
          })
        }

        dataPoligono()

      } catch (error) {

      }
    } else {
      console.log('ejucutar normal');

      reset({
        ...form.getValues(),
        provincia: provincia_data?.codigo,
        ciudad: ciudad_data?.codigo,
        zona: zona_data?.codigo,
        sector_tentativo: preventa_corporativa_data?.sector_tentativo
      })
    }


    setNoForm({
      ...prospecto_corporativo_data,
      ...preventa_corporativa_data,
      ...rest
    } as any)


    return () => {

    }
  }, [factibilidadCorporativa])


  useEffect(() => {
    if (!isVisibleCalendario && flotasCorporativas.length==0) {
      getFlotas({
        es_corporativo: true,
        page_size:200,
      });
    }

    return () => { }
  }, [])

  useEffect(() => {

    return () => {
      clearSelectedItems(MaterialesKey.ingresoProductos);
    }

  }, [])


  ///* handle
  const handleSendForm = async (form: FormAgendaCorporativo) => {
    const sendForm = {
      ...form,
      estado_agenda: EstadosAgendamientoEnumChoice.APROBADO,
      factibilidad_corporativa: factibilidadCorporativa.codigo,
      preventa_corporativa: factibilidadCorporativa.preventa_corporativa_data?.codigo,
      prospecto_corporativo: factibilidadCorporativa.prospecto_corporativo_data?.codigo,
      hora_instalacion: dayjs(form.hora_instalacion).format('HH:mm:ss'),
      materiales_equipos_agendamiento: ingresoProductos,
    }

    const resp = await mutateAsyncAgendaCorporativo(sendForm as any)

    if (resp.code === 200)
      await putPreventaCorporativo({
        ...sendForm,
        id_preventa_coorporativa: factibilidadCorporativa.preventa_corporativa_data?.id_preventa_coorporativa,
        sector_tentativo: form.sector_tentativo ? form.sector_tentativo : undefined,
        sector: !form.sector_tentativo ? form.sector : undefined,
        //zona: !form.sector_tentativo ? form.zona : null
      })


    if (resp.code === 200 && form.estado_llamada == EstadosLlamadaEnumChoice.REALIZADA)
      await putFactibilidadCorporativo({
        ...sendForm,
        id_factibilidad_coorporativa: factibilidadCorporativa.id_factibilidad_coorporativa,
        estado_factibilidad: EstadoFactibilidadEnum.FINALIZADO
      })


  }
  return (
    <>
      <TabsFormBoxScene
        titlePage={titlePage}
        showCustomBtns={true}
        content={
          <>
            {
              factibilidadCorporativa?.preventa_corporativa_data?.tipo_plan?
                <Typography>Cliente <b>{factibilidadCorporativa?.preventa_corporativa_data?.tipo_plan}</b></Typography>
              :null
            }
            {
              factibilidadCorporativa?.prospecto_corporativo_data?.condicion_venta?
                <Typography>Condición Venta: <b>{
                  factibilidadCorporativa?.prospecto_corporativo_data?.condicion_venta
                }</b></Typography>
              :null
            }
          </>
        }
        customBtns={
          <CustomButtunsRejectConfirm
            onCancel={() => navigate(ROUTER_PATHS.noc.agendamientoNocNav)}
            onConfirm={handleSubmit(handleSendForm, (error) => {
              console.log('error: ', error);
              handleErrorForm(error)
            })}
            showRejectBtn={false}
            rejectTextBtn="Enviar Gestión de Venta"
            onReject={() => {



            }}
            sxContainer={{
              pt: 9,
            }}
          />
        }
        pb={0}
        tabs={
          <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
            <Tab label="FACTIBILIDAD CORPORATIVA" value={1} {...a11yProps(1)} />
            <Tab label="INFORMACION ADICIONAL" value={2} {...a11yProps(2)} />
            <Tab label="MATERIAL Y EQUIPOS" value={3} {...a11yProps(3)} />
          </FormTabsOnly>
        }
        children={
          <>
            <CustomTabPanel index={1} value={valueTab}>
              <TabInformacionAgendaNoc
                form={form}
                noForm={noForm}
                factibilidadCorporativa={factibilidadCorporativa}
                isLoadingSectors={isLoadingSectors}
                sectorsByZonePaging={sectorsByZonePaging}
                provinceByCountry={provinceByCountry}
                isLoadingProvinceByCountry={isLoadingProvinceByCountry}
                citiesByProvince={citiesByProvince}
                isLoadingCities={isLoadingCities}
              />
            </CustomTabPanel>

            <CustomTabPanel index={2} value={valueTab}>
              <TabInformacionAdicionalAgendaNoc
                form={form}
                noForm={noForm} />
            </CustomTabPanel>

            <CustomTabPanel index={3} value={valueTab}>
              <TabMaterialesEquiposNoc
                dataFactibilidadCorporativa={factibilidadCorporativa}
                // form={form}
                // noForm={noForm} 
              />
            </CustomTabPanel>

          </>
        }

      />



    </>
  )

}